import { render, staticRenderFns } from "./addHsaf.vue?vue&type=template&id=7af89096"
import script from "./addHsaf.vue?vue&type=script&lang=js"
export * from "./addHsaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports